import Vue from 'vue';
import Vuex from 'vuex';
import api from './api';

const debug = process.env.NODE_ENV !== 'prod';

Vue.use(Vuex);

const state = {
  pageIdCode: '',
  openModal: false,
  product: {},
  coursePage: {},
  products: [],
  modalContent: {},
  systemModalContent: {},
};

const mutations = {
  ['SET_PAGE_ID'](state, pageIdCode) {
    state.pageIdCode = pageIdCode;
  },
  ['SET_PRODUCTS'](state, products) {
    state.products = products;
  },
  ['SET_COURSE_PAGE'](state, coursePage) {
    state.coursePage = coursePage;
  },
  ['SET_ASSETS'](state, assets) {
    state.assets = assets;
  },
  ['SET_SYSTEM_MODAL_CONTENT'](state, payload) {
    state.systemModalContent = payload.modalContent;
  },
  // 이게 계속 사용될까요?
  ['CALL_MODAL'](state, product = {}) {
    state.product = product;
    state.openModal = !state.openModal;
  },
};

const actions = {
  // 이게 계속 사용될까요?
  callModal({ commit }, payload) {
    commit('CALL_MODAL', payload);
  },
  async setCourseProducts({ commit }, { courseId }) {
    try {
      const response = await api.findCourseProductsToSale({ courseId });
      if (response && response.data && response.data.data && response.data.data.products) {
        commit('SET_PRODUCTS', response.data.data.products);
      }
      if (response && response.data && response.data.data && response.data.data.coursePage) {
        commit('SET_COURSE_PAGE', response.data.data.coursePage);
      }
    } catch (err) {
      commit('SET_SYSTEM_MODAL_CONTENT', {
        modalContent: {
          title: '상품 정보를 가져오는데 실패했습니다.',
          message: '서버 오류로 인해 상품 목록을 불러올 수 없습니다. 잠시 후 다시 시도해주세요.',
          confirm: true,
          isDark: true,
        },
      });
    }
  },
  // system modal
  setSystemConfirmModal({ commit }, payload) {
    commit('SET_SYSTEM_MODAL_CONTENT', {
      modalContent: { title: payload.title, message: payload.message, confirm: true, isDark: true },
    });
  },
  clearSystemModalContent({ commit }) {
    commit('SET_SYSTEM_MODAL_CONTENT', { modalContent: {} });
  },
};

const store = new Vuex.Store({
  strict: debug,
  state,
  mutations,
  actions,
});

export default store;
